/** Полный URL STOMP WebSocket для клиентского чата */
export const chatWsUrl = "wss://chat-ru.d-keys.info:8765/ws";
/** Путь регистрации клиента после подключения к WS */
export const chatRegisterDestination = "/app/user.register";

/** Путь отправки сообщения клиентом */
export const chatSendDestination = "/app/user.sendMessage";

/** Базовый префикс пользовательских топиков */
export const chatUserTopicPrefix = "/topic/user";

/** Максимум сообщений в ленте */
export const maxChatMessages = 50;

/** Интервал heartbeat STOMP для поддержания WS-соединения в онлайн-режиме (мс) */
export const chatHeartbeatMs = 5000;

/** Таймаут установки STOMP-соединения (мс) */
export const chatConnectionTimeoutMs = 8000;

/** Максимум попыток переподключения после разрыва соединения */
export const chatReconnectMaxAttempts = 5;

/** Интервал между попытками переподключения (мс) */
export const chatReconnectIntervalMs = 10000;

/** Сообщение пользователю при исчерпании попыток переподключения */
export const chatReconnectFailedMessage =
  "Сервера поддержки не доступны. Повторите попытку позже.";
